"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const DashboardService_1 = __importDefault(require("modules/dashboard/DashboardService"));
class TrackUtils {
    static getLearningTrackArticleUrl(shortLocale) {
        let locale = 'en';
        if (shortLocale === 'pt') {
            locale = 'pt-BR';
        }
        if (shortLocale === 'es') {
            locale = 'es';
        }
        return `${Settings_1.default.app.helpCenter}/${locale}/article/como-criar-uma-trilha-de-conhecimento-no-hotmart-club/17310210527757`;
    }
    static async getAccessHotmartClubUrl(productId) {
        const data = await DashboardService_1.default.hasNewClub(productId);
        if (!(0, isEmpty_1.default)(data)) {
            return `${Settings_1.default.app.bw}/membership/${data.slug}/products`;
        }
        return `${Settings_1.default.app.bw}/membership`;
    }
}
exports.default = TrackUtils;
